if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText =
          this.submitButton.querySelector('.btn_text, span:not(.sold-out-message)') ||
          this.submitButton.querySelector('span');
        this.buttonShell = this.querySelector('.add_cart_btn');
        this.isSeapuriCardForm = Boolean(this.closest('.product-card-wrapper.seapuri-featured-card'));
        this.isSubmitting = false;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.bindDecorativeButtonShell();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.isSubmitting || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.isSubmitting = true;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (!this.isSeapuriCardForm) {
          this.querySelector('.loading__spinner')?.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const defaultVariantId =
          formData.get('id') ||
          this.variantIdInput?.value ||
          this.form.querySelector('[name="id"]')?.value;
        if (defaultVariantId && !formData.get('id')) {
          formData.set('id', defaultVariantId);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const publishCartUpdate = () => {
              if (this.error) return;
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            };
            this.error = false;
            const quickAddModal = this.closest('bz-quick-view');
            const BzModal = this.closest('bz-modal');
            if(BzModal){
              BzModal?.close();
            }
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    publishCartUpdate();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.isSeapuriCardForm) {
                this.releaseLoadingState(true);
                return new Promise((resolve) => {
                  requestAnimationFrame(() => {
                    this.cart.renderContents(response);
                    publishCartUpdate();
                    resolve();
                  });
                });
              }
              this.cart.renderContents(response);
              publishCartUpdate();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.isSubmitting = false;
            this.releaseLoadingState(!this.error);
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          });
      }

      releaseLoadingState(removeDisabled = false) {
        this.submitButton.classList.remove('loading');
        if (removeDisabled) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner')?.classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      bindDecorativeButtonShell() {
        if (!this.buttonShell || this.buttonShell.dataset.submitProxyBound === 'true') return;
        this.buttonShell.dataset.submitProxyBound = 'true';
        this.buttonShell.addEventListener('click', (event) => {
          const interactiveTarget = event.target.closest('button, a, input, select, textarea, label');
          if (interactiveTarget) return;
          if (!this.submitButton || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
          if (this.form.requestSubmit) {
            this.form.requestSubmit(this.submitButton);
          } else {
            this.submitButton.click();
          }
        });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
